import { customAlphabet } from 'nanoid';

export const alphaNanoIdUtil = (size = 5): string => {
  const nanoid = customAlphabet(
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
    size
  );
  return nanoid();
};
